var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSavebar)?_c('div',{staticClass:"confirmation-bar"},[(!_vm.deleteAction)?_c('Btn',{staticClass:"brand d-inline-block m-r-15",attrs:{"icon":{
      name: 'check',
      size: '18',
    },"btnText":_vm.$t('save')},on:{"btnClick":_vm.confirm}}):_vm._e(),(_vm.deleteAction)?_c('Btn',{staticClass:"red d-inline-block m-r-15",attrs:{"icon":{
      name: 'deleteForever',
      size: '16',
    },"btnText":_vm.$t('delete')},on:{"btnClick":_vm.confirm}}):_vm._e(),_c('Btn',{staticClass:"light d-inline-block",attrs:{"icon":{
      name: 'remove',
      size: '22',
    },"btnText":_vm.$t('cancel')},on:{"btnClick":_vm.cancel}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }